import { ListItemIcon, MenuItem } from '@mui/material';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

export const ItemMenuList = ({ list }) => {
  return (
    <>
      {list.map((item) => (
        <MenuItem
          key={item.key}
          component={NavLink}
          to={item.to}
          sx={{ paddingTop: '10px', paddingBottom: '10px' }}
          // onClick={(e) => setOpen(false)}
          activeClassName='Mui-selected'
          exact
        >
          <ListItemIcon sx={{ color: 'default.main' }}>{item.icon()}</ListItemIcon>
          {item.label}
        </MenuItem>
      ))}
    </>
  );
};
